/* import __COLOCATED_TEMPLATE__ from './range-filter.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import moment from 'moment-timezone';
import type OptimizeSuggestionsService from 'embercom/services/optimize-suggestions-service';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';

interface Signature {
  Args: {
    dateRange: string;
    onDateRangeChange: (value: string) => void;
  };
}

export default class RangeFilter extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare optimizeSuggestionsService: OptimizeSuggestionsService;
  @service declare appService: AppService;

  get dateRangeLabel(): string {
    switch (this.args.dateRange) {
      case 'past-week':
        return this.intl.t(
          'components.reporting.automation.optimize-suggestions.filter.date-range.past-week',
        );
      case 'past-month':
        return this.intl.t(
          'components.reporting.automation.optimize-suggestions.filter.date-range.past-month',
        );
      case 'all':
        return this.intl.t(
          'components.reporting.automation.optimize-suggestions.filter.date-range.all',
        );
      default:
        // Format timestamp as date
        if (this.args.dateRange) {
          let momentDate = moment.tz(this.args.dateRange, this.appService.app.timezone);
          return momentDate.format('MMM D, YYYY');
        }
        return this.intl.t(
          'components.reporting.automation.optimize-suggestions.filter.date-range.all',
        );
    }
  }

  get dateRangeOptions(): Array<{ value: string; label: string }> {
    return this.optimizeSuggestionsService.getSuggestionGenerationDates().map((date) => ({
      value: date.timestamp ?? '',
      label: date.label,
    }));
  }

  @action
  handleDateRangeChange(value: string): void {
    this.args.onDateRangeChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::Filters::RangeFilter': typeof RangeFilter;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filters/range-filter': typeof RangeFilter;
  }
}
